<template>
  <div>
    <b-modal id="staffPosition" title="Staff Position" size="xl">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Staff Position
        </div>
      </template>

      <div class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="lock-header">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Staff</th>
                <th v-for="(item, index) of params" :key="'head' + index">{{ item['label'] }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(staff, index) of selectedStaffs" :key="'staff_' + index">
                <td>
                  <label class="form-label">{{ staff['name'] }}</label>
                </td>
                <td v-for="(param, index) of params" :key="'param' + index" style="min-width: 250px">
                  <div class="custom-control custom-checkbox mb-2">
                      <input type="checkbox" class="custom-control-input" :id="'credit_' + staff['id'] + '_' + param['value']" v-model="data[staff['id']][param['value'] + '_include_credit']">
                      <label class="custom-control-label" :for="'credit_' + staff['id'] + '_' + param['value']">Credit</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-2">
                      <input type="checkbox" class="custom-control-input" :id="'package_' + staff['id'] + '_' + param['value']" v-model="data[staff['id']][param['value'] + '_include_package']">
                      <label class="custom-control-label" :for="'package_' + staff['id'] + '_' + param['value']">Package</label>
                  </div>
                  <div style="display: flex" v-for="(item, index) of data[staff['id']][param['value']]" :key="'senior' + staff['id'] + index">
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['min']"
                      type="number"
                      :searchable="false"
                      :show-labels="false"
                      @change="onSeniorChange(staff['id'], param['value'], true)" />
                    <span style="margin-top: 10px; max-height: 30px">&nbsp;-&nbsp;</span>
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['max']"
                      type="number"
                      readonly
                      disabled
                      :searchable="false"
                      :show-labels="false" />
                    &nbsp;&nbsp;&nbsp;
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['comm']"
                      :searchable="false"
                      :show-labels="false" />
                    <button type="button" class="btn btn-danger" @click="onSeniorRemove(staff['id'], param['value'], index)">x</button>
                  </div>
                  <button type="button" class="btn btn-primary" @click="onSeniorAdd(staff['id'], param['value'])">+</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>
<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "staffPosition",
  data() {
    return {
      showLoading: false,
      outlets: [],
      positions: ['Senior', 'Junior'],
      staffs: [],
      selectedStaffs: [],

      selectedOutlet: {},
      data: {},
      params: [
        { value: 'personal', label: 'Personal Sales Commission (%)' },
        { value: 'service', label: 'Service Sales Commission (%)' },
        { value: 'product', label: 'Product Sales Commission (%)' },
        { value: 'package', label: 'Package Sales Commission (%)' },
        { value: 'outstandings', label: 'Outstanding Sales Commission (%)' },
        { value: 'monthly', label: 'Monthly Allowance' },
        { value: 'quarter', label: 'Quarterly Allowance' },
        // { value: 'attendance', label: 'Attendance Commission' },
      ]
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('staffPosition')
      this.loadStaff()
    },

    onOutletChange() {
      this.selectedStaffs = []
      for (let staff of this.staffs) {
        if (this.selectedOutlet.id === staff['outletID']) {
          this.selectedStaffs.push({ id: staff['staffID'], name: staff['name'] + ' - ' + staff['mobile'], outletID: staff['outletID'] })
        }
      }

      this.data = {}
      this.loadCommission()
    },

    loadStaff() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://staff.tunai.io/business/staff',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.staffs = response.data.staffs || {}
          this.onOutletChange()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadCommission() {
      this.data = {}
      for(let staff of this.staffs) {
        this.data[staff['staffID']] = {}
        for(let param of this.params) {
          this.data[staff['staffID']][param['value']] = [{ min: '', max: '', comm: '' }]
        }
      }
      
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_Oriya_fixedCommission_staff_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_Oriya_fixedCommission_staff_setting`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false

          for (let staffID in (response.data || [])) {
            for(let param in (response.data[staffID] || {})) {
              this.data[staffID][param] = response.data[staffID][param] || [{ min: '', max: '', comm: '' }]
              this.onSeniorChange(staffID, param)
            }
          }

          this.$forceUpdate()
        })
        .catch((err) => {
          console.log(err)
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    save() {
      this.showLoading = true

      let request = {}
      for (let key in this.data) {
        request[key] = this.data[key]
      }

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_Oriya_fixedCommission_staff_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_Oriya_fixedCommission_staff_setting`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('staffPosition')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    onSeniorRemove(staffId, serviceId, index) {
      this.data[staffId][serviceId].splice(index, 1)
      this.onSeniorChange(staffId, serviceId)
      this.$forceUpdate()
    },
    onSeniorAdd(staffId, serviceId) {
      this.data[staffId] = this.data[staffId] || {}
      this.data[staffId][serviceId] = this.data[staffId][serviceId] || []
      this.data[staffId][serviceId].push({ min: '', max: '', comm: '' })
      this.$forceUpdate()
    },
    onSeniorChange(staffId, serviceId, forceUpdate) {
      if (this.data && this.data[staffId] && this.data[staffId][serviceId]) {
        for (let i = 0; i < this.data[staffId][serviceId].length; i++) {
          if (this.data[staffId][serviceId][i]) {
            let min = parseFloat(this.data[staffId][serviceId][i]['min'])
            if(i > 0 && !isNaN(min)) {
              this.data[staffId][serviceId][i - 1]['max'] = min - 0.01
            }
          }
        }

        if(forceUpdate) {
          this.$forceUpdate()
        }
      }
    },
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>
<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}

.lock-header {
	overflow: -moz-scrollbars-vertical; 
  overflow-y: scroll;
  max-height: 75vh;
}

.lock-header thead {
  position: sticky;
  top: 0;
	background-color: #fff;
	z-index: 11;
}

.lock-header td:nth-child(1) {
  position: sticky;
  left: 0;
	background-color: #fff;
  z-index: 10;
}

.lock-header tr:nth-of-type(odd) td:nth-child(1) {
    background-color: #f4f4f4;
}
</style>